import { types, actions } from './requests'
export const RECAP_TYPES = {
    ...types('RECAP'),
}
export const RECAP_ACTIONS = {
    ...actions('RECAP'),
}
